export default __webpack_public_path__ + "static/media/Diseasecard.394b7a22.webp";